<template>
  <div class="header" ref="Box">
    <header class="nav-warp">
      <div>
        <a class="nav-logo" href="/"><img src="../assets/img/wz_logo.png" /></a>
        <div class="nav-menu">
          <router-link to="/" :style="'/' == $route.path ? 'color:#14c86c;' : ''">首页</router-link>
          <router-link to="/tech" :style="'/tech' == $route.path ? 'color:#14c86c;' : ''">解决方案</router-link>
          <!-- <router-link to="/product" :style="'/product' == $route.path ? 'color:#14c86c;' : ''">产品与服务</router-link> -->
          <!-- <router-link to="/news" :style="'/news' == $route.path ? 'color:#14c86c;' : ''">新闻中心</router-link> -->
          <!-- <router-link to="/cardiobrain" :style="'/cardiobrain' == $route.path ? 'color:#14c86c;' : ''">心脑血管</router-link> -->
          <a  href="http://hapi.wuzhengai.com" target="_blank">开放平台</a>

          <router-link to="/features" :style="'/features' == $route.path ? 'color:#14c86c;' : ''">健康AI认知大脑</router-link>
          <router-link to="/about" :style="'/about' == $route.path ? 'color:#14c86c;' : ''">关于我们</router-link>
        </div>
        <div class="nav-signup">
          <div class="nav-login" v-if="!kaiguan">
            <a href="javascript:void(0);" @click="login">登录</a>
            <a href="javascript:void(0);" @click="register">注册</a>
          </div>
          <div class="nav-signout" v-if="kaiguan">
            <div  @click="ps" class="a"><img :src="img">{{name}}</div>
            <div  @click="remove" class="a"><i></i>退出</div>
          </div>
        </div>
      </div>
    </header> 
  </div>
</template>

<script>
  import { getToken, setToken, removeToken } from '@/utils/auth'
  import Cookies from 'js-cookie'
  import { profile } from '@/api/user';
export default {
  data () {
    return {
      img:'',
      name:'',
      kaiguan:false,
      scrollTops: 0
    }
  },
  methods: {
    remove(){
      let _this = this;
     _this.$confirm('确定注销并退出系统吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            removeToken();
            _this.logining ();
          })
    },
    ps(){
       this.$router.push("/personCenter");
    },
    // 登录ing
    logining () {
      let _this = this;
      Cookies.set('typein',1);
      profile().then(response => {
        if (response.data.code == 200) {

          _this.kaiguan = true;
           _this.name =  response.data.data.realName;
          _this.img = response.data.data.picImg;

        }else{
          _this.kaiguan = false;
        }
      })
    },
    // 登录
    login () {
      this.$router.push('/login');
    },
    // 注册
    register () {
      this.$router.push('/register');
    },
    // 滚动事件,绑定到元素div块
    // 如果不绑定到元素上，则只能监听页面滚动
    Scroll () {
      let _this = this;
      //滚动条的高度
      _this.scrollTops = document.body.scrollTop || document.documentElement.scrollTop;
      //滚动条的高度>可视区的高度
      if (_this.scrollTops > 64) {
        $(".nav-warp").addClass("tophaeader");
      } else if (_this.scrollTops < 64) {
        if(this.$route.path!='/topic'&&this.$route.path!='/pdf'){
             $(".nav-warp").removeClass("tophaeader");
         }else{
            $(".nav-warp").addClass("tophaeader");
         }



      }
    }
  },
  mounted () {
    if(this.$route.path!='/topic'&&this.$route.path!='/pdf'){
       document.addEventListener('scroll', this.Scroll, true);
   }else{
      $(".nav-warp").addClass("tophaeader");
   }

    this.logining ();
  },
}
</script>

<style scoped>
/* -----=====头部导航=====----- */
.nav-warp {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0,0.1 );
}
.nav-warp > div {
  width: 1200px;
  margin: 0 auto;
  height: 64px;
  position: relative;
}
.nav-warp .nav-logo {
  float: left;
  padding: 16px 0;
  position: absolute;
  left: 0;
  z-index: 2;
}
.nav-warp .nav-menu {
  width: 100%;
  position: absolute;
  padding: 16px 240px 16px 140px;
  text-align: center;
  z-index: 1;
}
.nav-warp .nav-menu a {
  padding: 0 20px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  position: relative;
}
.nav-warp .nav-menu a:hover,
.nav-warp .nav-menu a.active {
  color: #14c86c;
}
.nav-warp .nav-signup {
  float: right;
  padding: 17px 0;
  position: absolute;
  right: 0;
  z-index: 2;
}
.nav-warp .nav-login a {
  float: left;
  width: 110px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-left: 10px;
  font-size: 16px;
  color: #0ebf65;
  background: #fff;
  overflow: hidden;
  position: relative;
  z-index: 1;
  transition: all 0.2s;
}
.nav-warp .nav-login a:before {
  content: "";
  display: block;
  width: 200%;
  height: 100%;
  position: absolute;
  left: -100%;
  top: 0;
  z-index: -1;
  transform-origin: 0 0;
  transform: rotate(-90deg);
  transition: all 0.2s;
}
.nav-warp .nav-login a:nth-of-type(1) {
  color: #0ebf65;
  background: #fff;
}
.nav-warp .nav-login a:nth-of-type(1):hover {
  color: #fff;
}
.nav-warp .nav-login a:nth-of-type(1):before {
  background: #14c86c;
}
.nav-warp .nav-login a:nth-of-type(2) {
  color: #fff;
  background: #14c86c;
}
.nav-warp .nav-login a:nth-of-type(2):before {
  background: #fff;
}
.nav-warp .nav-login a:hover:nth-of-type(2) {
  color: #0ebf65;
}
.nav-warp .nav-login a:hover:before {
  transform: rotate(0deg);
}
.nav-warp .nav-signout {
  float: right;
  position: relative;
  z-index: 9;
  cursor: pointer;
}
.nav-warp .nav-signout .a {
  float: left;
  background: none;
  margin-left: 30px;
  color: #fff;
  line-height: 30px;
  font-size: 14px;
}
.nav-warp .nav-signout .a img {
  float: left;
  width: 30px;
  height: 30px;
  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  overflow: hidden;
  margin-right: 10px;
}
.nav-warp .nav-signout .a i {
  float: left;
  margin-top: 7px;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  background: url(../assets/img/out_icon.png) no-repeat center;
}
.nav-warp .nav-signout a:hover {
  color: #14c86c;
}
.tophaeader {
  background: #262728;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue